// The /files search parameter: the current folder as `a/b`; anything else is dropped, not fatal.
import { z } from "zod";

export interface FilesSearch {
  path?: string;
}

// The router reads `?path=2026` as a number; a folder named so is still a path.
const FilesSearchSchema = z.object({
  path: z
    .union([z.string(), z.number()])
    .transform(String)
    .pipe(z.string().trim().min(1).max(400))
    .optional()
    .catch(undefined),
});

export const validateFilesSearch = (raw: Record<string, unknown>): FilesSearch => {
  const { path } = FilesSearchSchema.parse(raw);
  return path ? { path } : {};
};
